import {
    SET_SELECTED_ELEMENT,
    SET_SELECTED_PROJECT,
} from '../actions/ScannedProject';

const initialState = {
    selectedProject: null,
    selectedElement: null,
};
  
export default function ScannedProjectReducer(state = initialState, action) {
    switch (action.type) {
        case SET_SELECTED_PROJECT: {
            return {
                ...state,
                selectedProject: action.selectedProject,
            };
        }

        case SET_SELECTED_ELEMENT: {
            return {
                ...state,
                selectedElement: action.selectedElement,
            };
        }

        default: {
            return state;
        }
    }
}